import React from 'react';
import './WelcomeBackModal.css'; // Assuming you have this for styling

function WelcomeBackModal({ open, gameState, onContinue }) {

  if (!open || !gameState || !gameState.levels || gameState.levels.length === 0) {
    return null; // Don't render if not open or gameState is invalid
  }

  // Get data from the last (current) level object in the gameState
  const currentLevelData = gameState.levels[gameState.levels.length - 1];
  const levelIndex = currentLevelData.level; // 0-indexed
  const humanReadableLevel = levelIndex + 1;

  let title = "Welcome back!";
  let messageLines = [];
  let continueButtonText = "Continue";

  // --- Determine the message based on gameState ---

  // Check if the last guess was correct (all green) to handle cases where pendingSkillUp flag is missing
  const lastGuess = currentLevelData?.guesses?.length > 0 ? currentLevelData.guesses[currentLevelData.guesses.length - 1] : null;
  const isLevelCracked = lastGuess && lastGuess.feedback && lastGuess.feedback.every(f => f === 'green');

  if (gameState.pendingSkillUp || (!gameState.gameFinished && isLevelCracked)) {
    // This state means they won the currentLevelData and are waiting to skill up
    title = "Nicely Done!";
    messageLines.push(`You cracked Level ${humanReadableLevel}!`);
    // If currentLevelData has guessesUsed, you can add it:
    if (currentLevelData.guessesUsed !== undefined && currentLevelData.crackedOnGuess) {
      messageLines.push(`You used ${currentLevelData.crackedOnGuess} guess${currentLevelData.crackedOnGuess === 1 ? '' : 'es'}.`);
    }
    continueButtonText = "Continue";
  } else if (gameState.gameFinished) {
    // Game is fully over (either won all levels or lost a level)
    // App.js might handle showing a different summary view, but this modal can acknowledge it.
    title = gameState.overallWin ? "Congratulations!" : "Game Over";
    messageLines.push(`You've completed this game.`);
    if (gameState.overallWin) {
      messageLines.push("You successfully cracked all the codes!");
    } else {
      // Find the level they lost on, if possible, or a generic message
      const lastAttemptedLevel = gameState.levels.find(l => !l.completed && l.guesses.length > 0) || currentLevelData;
      messageLines.push(`You lost on Level ${lastAttemptedLevel.level + 1}. Better luck next time!`);
    }
    continueButtonText = "Continue"; // Or "Close", or App.js might hide this modal and show results directly
    // For now, `onContinue` might just close the modal.
  } else if (currentLevelData) {
    // Game is in progress on the currentLevelData
    const guessesMade = currentLevelData.guesses ? currentLevelData.guesses.length : 0;
    // guessesAllowed should be present on currentLevelData, set by createNewLevel
    const guessesAllowed = currentLevelData.guessesAllowed || (gameState.hardMode ? levelIndex + 4 : 6); // Fallback if not present
    let guessesRemaining = 0;

    if (guessesAllowed > 0) { // Ensure guessesAllowed is valid
      guessesRemaining = guessesAllowed - guessesMade;
    }

    messageLines.push(`You are on Level ${humanReadableLevel}.`);

    if (guessesRemaining >= 0) {
      const guessesMadeTextPart = `You've used ${guessesMade} guess${guessesMade === 1 ? '' : 'es'}`;
      const guessesLeftTextPart = `you have ${guessesRemaining} guess${guessesRemaining === 1 ? '' : 'es'} left`;
      messageLines.push(`${guessesMadeTextPart}, ${guessesLeftTextPart} to crack the code.`);
    } else {
      // This state (negative remaining guesses) implies the game should have been over,
      // or guessesMade exceeds guessesAllowed.
      // The gameFinished flag should ideally catch this earlier.
      // For this message, we can acknowledge all guesses were used if guessesMade >= guessesAllowed.
      if (guessesMade >= guessesAllowed) {
        messageLines.push(`You've used all ${guessesMade} guess${guessesMade === 1 ? '' : 'es'} for this level.`);
      } else {
        // Fallback if something is unexpected with guess counts
        messageLines.push(`You've made ${guessesMade} guess${guessesMade === 1 ? '' : 'es'}.`);
      }
    }
  } else {
    // Fallback if currentLevelData is somehow missing but game is not finished/pending skillup
    messageLines.push("Ready to resume your game?");
  }

  return (
    <div className="modal-overlay">
      <div className="welcome-modal-content" onClick={e => e.stopPropagation()}>
        <h2>{title}</h2>
        {messageLines.map((line, index) => (
          <p key={index}>{line}</p>
        ))}
        <button className="continue-button" onClick={onContinue}>
          {continueButtonText}
        </button>

      </div>
    </div>
  );
}

export default WelcomeBackModal;